module.exports = __webpack_public_path__ + "img/transaction_flow.26c7dc17.png";